
(function() {
    // https://stackoverflow.com/a/14428377
    var iframes = document.querySelector('.typography')
    if (iframes) {
        iframes = iframes.getElementsByTagName('iframe');
        var key = /www.youtube.com/;
        for (var i = 0; i != iframes.length; ++i) {
            var match = iframes[i].src.search(key);
            if (match != -1) {
                iframes[i].outerHTML = '<div class="youtube-wrapper">' + iframes[i].outerHTML + '</div>';
            }
        }
    }

    var youtubeLink = document.querySelector('.js-youtube');
    if (youtubeLink) {
        youtubeLink.addEventListener('click', function(event){
            event.preventDefault();
            showYoutubeModal();
        });
        document.querySelector('[gr-overlay]').addEventListener('click', function(){
            closeModal();
        })
    }

    function showYoutubeModal() {
        document.body.classList.add('show-modal');
        var youtubeModal = document.createElement('div');
        youtubeModal.setAttribute('class', 'modal--youtube');
        var youtubeWrapper = document.createElement('div');
        youtubeWrapper.setAttribute('class', 'youtube-wrapper');
        youtubeWrapper.innerHTML = '<iframe width="560" height="314" src="https://www.youtube.com/embed/' + getVideoId(youtubeLink.href) + '?rel=0&autoplay=1&enablejsapi=1"' + ' allowfullscreen="allowfullscreen"></iframe>';
        youtubeModal.appendChild(closeModalTrigger());
        youtubeModal.appendChild(youtubeWrapper);
        document.body.appendChild(youtubeModal);
    }

    function closeModalTrigger() {
        var closeModal = document.createElement('div')
        closeModal.setAttribute('class', 'modal__close');
        closeModal.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M231.6 256l130.1-130.1c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L192 216.4 61.9 86.3c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17L152.4 256 22.3 386.1c-4.7 4.7-4.7 12.3 0 17l22.6 22.6c4.7 4.7 12.3 4.7 17 0L192 295.6l130.1 130.1c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17L231.6 256z"/></svg>';
        closeModal.addEventListener('click', function(){
            document.body.classList.remove('show-modal');
            document.body.removeChild(document.querySelector('.modal--youtube'));
        });
        return closeModal;
    }

    function closeModal() {
        document.body.classList.remove('show-modal');
        document.body.removeChild(document.querySelector('.modal--youtube'));
    }

    function getVideoId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return 'error';
        }
    }

})(jQuery);
